export class TraceabilityProducer {
  /** ID */
  id: string

  /** Producer name */
  name: string

  /** Cooperative group ID */
  idCoop: number

  constructor(producer: TraceabilityProducer) {
    this.id = producer.id || ''
    this.name = producer.name || ''
    this.idCoop = producer.idCoop || undefined
  }
}
